import ConstraintResponsables from './ConstraintResponsables';
import './ConstraintResponsables.css';
export default ConstraintResponsables;
